export default {
    section: 'Sale Price',
    name: 'offer-letter-price',
    items: [
        {
            type: 'text-field',
            text: 'Sale Price',
            name: 'offer-letter-price-value',
            width: 3,
            props: {
                label: 'Sale Price',
                format: 'dollars'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/price.js